/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1NotificationMobileAppSharedClassStudentsQueryResponse,
  GetApiV1NotificationMobileAppSharedClassStudentsQueryParams,
  GetApiV1NotificationMobileAppSharedClassStudents401,
  GetApiV1NotificationMobileAppSharedClassStudents500,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppSharedClassStudents.ts";

function getGetApiV1NotificationMobileAppSharedClassStudentsUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/notification/mobile-app/shared/class-students` as const,
  };
  return res;
}

/**
 * @description Retorna turmas paginadas (20 por página) filtradas por nome ou código. Inclui a quantidade total de matriculados por turma. **(Requer Authorization para autenticação)**
 * @summary Busca turmas para seleção de notificação (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app/shared/class-students}
 */
export async function getApiV1NotificationMobileAppSharedClassStudents(
  params?: GetApiV1NotificationMobileAppSharedClassStudentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1NotificationMobileAppSharedClassStudentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1NotificationMobileAppSharedClassStudents401
      | GetApiV1NotificationMobileAppSharedClassStudents500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1NotificationMobileAppSharedClassStudentsUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
